import _ from "lodash";
import moment from "moment";
import { Component } from "react";
import { withRouter } from "react-router-dom";
import locales from "../../../_constants/locales";
import GeneralInformationSection from "../containers/GeneralInformationSection";
import "../styles/TicketPage.css";
import RelatedTicketsSection from "./RelatedTicketsSection";
import RequestSection from "./RequestSection";

class Ticket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedReturnItems: [],
            expandedReplacementItems: [],
            isUpdateAddressDialogOpen: false,
            itemDetails: null,
            itemDetailsOpen: false
        };
    }

    componentWillMount() {
        if (!this.props.countryListLoading && this.props.countryList.length === 0) {
            this.props.getCountryList();
        }
        if (!this.props.referencePlatformListLoading && this.props.referencePlatformList.length === 0) {
            this.props.getReferencePlatformList();
        }
        if (!this.props.requestTypeListLoading && this.props.requestTypeList.length === 0) {
            this.props.getRequestTypeList();
        }
        if (!this.props.returnReasonListLoading && this.props.returnReasonList.length === 0) {
            this.props.getReturnReasonList();
        }
    }

    handleDownloadReturnLabelClick(requestId) {
        this.props.getReturnLabel(this.props.ticketId, requestId);
    }

    handleTicketUpdate(ticket) {
        this.props.updateTicket(this.props.ticketId, ticket);
    }

    requestIsCancelled(request) {
        return request.requestLogs && request.requestLogs.some(log => log.status && log.date && log.status.code == "CANCELLED");
    }

    requestIsCompleted(request) {
        return (
            !this.requestIsCancelled(request) &&
            request.requestLogs &&
            request.requestLogs.some(
                log =>
                    request.requestType &&
                    log.status &&
                    log.date &&
                    (log.status.code === "CLOSED" ||
                        (request.requestType.code === "REPLACEMENT" && log.status.code === "SHIPMENT_DELIVERED") ||
                        (request.requestType.code === "REFUND" && log.status.code === "RETURN_RECEIVED") ||
                        (request.requestType.code === "RETURN_ONLY" && log.status.code === "RETURN_RECEIVED") ||
                        (request.requestType.code === "SHIP_ONLY" && log.status.code === "SHIPMENT_DELIVERED"))
            )
        );
    }

    handleBackToTicketSeachClick(e) {
        e.preventDefault();
        this.props.history.push("/tickets/search");
    }

    render() {
        return (
            <div className="flex layout vertical center ticket-container">
                <section className={`flex layout center ticket center-justified${this.state.cancel_order_window_open ? " in-background" : ""}`}>
                    <div className="navigation-panel">
                        <a className="action-button" href={`${process.env.PUBLIC_URL}/tickets/search`} onClick={this.handleBackToTicketSeachClick.bind(this)}>
                            {`${locales[this.props.language.code].TICKET_SEARCH.TITLE}`}
                        </a>
                    </div>
                    <div className="ticket-header">
                        <div className="flex layout horizontal">
                            <div className="flex layout vertical">
                                <h1 className="ticket-title">
                                    {locales[this.props.language.code].TICKET.TITLE} {this.props.ticket.ticketNumber}
                                </h1>
                                <p className="created-date-info">
                                    {moment(new Date(this.props.ticket.createdAt)).locale(this.props.language.code.toLowerCase()).format("LL")}
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <NoticeSection countryCode={this.props.ticket.replacementAddress.country.code} /> */}
                    {_.orderBy(
                        this.props.ticket.requests.filter(r => !this.requestIsCompleted(r) && !this.requestIsCancelled(r)),
                        ["id"],
                        ["desc"]
                    ).map((request, i) => {
                        let actions = [];
                        if (request.returnLabelAvailable !== null) {
                            let disabled = request.returnLabelAvailable === false || this.props.returnLabelLoading;
                            let className = `action-button${this.props.returnLabelLoading || request.returnLabelAvailable === false ? " disabled" : ""}`;
                            let onClick = request.returnLabelAvailable === true ? this.handleDownloadReturnLabelClick.bind(this, request.id) : () => {};
                            let label =
                                request.returnLabelAvailable === true
                                    ? locales[this.props.language.code].TICKET.REQUEST_DETAILS.DOWNLOAD_RETURN_LABEL
                                    : locales[this.props.language.code].TICKET.REQUEST_DETAILS.RETURN_LABEL_PENDING;

                            actions.push({
                                disabled: disabled,
                                loading: this.props.returnLabelLoading,
                                className: className,
                                onClick: onClick,
                                label: label,
                                icon: request.returnLabelAvailable === true ? "download" : null
                            });
                        }

                        return (
                            <RequestSection
                                key={i}
                                actions={actions}
                                language={this.props.language}
                                request={request}
                                isStatusProgressBarVisible={true}
                                view={"TICKET_PAGE"}
                            />
                        );
                    })}

                    {_.orderBy(
                        this.props.ticket.requests.filter(r => this.requestIsCompleted(r)),
                        ["id"],
                        ["desc"]
                    ).map((request, i) => {
                        return (
                            <RequestSection
                                actions={[]}
                                key={i}
                                language={this.props.language}
                                request={request}
                                isStatusProgressBarVisible={true}
                                view={"TICKET_PAGE"}
                            />
                        );
                    })}

                    {_.orderBy(
                        this.props.ticket.requests.filter(r => this.requestIsCancelled(r)),
                        ["id"],
                        ["desc"]
                    ).map((request, i) => {
                        return (
                            <RequestSection
                                key={i}
                                actions={[]}
                                language={this.props.language}
                                request={request}
                                isStatusProgressBarVisible={true}
                                view={"TICKET_PAGE"}
                            />
                        );
                    })}

                    <GeneralInformationSection
                        language={this.props.language}
                        ticket={this.props.ticket}
                        handleTicketUpdate={this.handleTicketUpdate.bind(this)}
                    />
                    {this.props.ticket.relatedTickets && this.props.ticket.relatedTickets.length > 0 && (
                        <RelatedTicketsSection
                            language={this.props.language}
                            relatedTickets={this.props.ticket.relatedTickets}
                            ticketNumber={this.props.ticket.ticketNumber}
                        />
                    )}
                    <div className="footer layout horizontal end-justified"></div>
                </section>
            </div>
        );
    }
}

export default withRouter(Ticket);
